import { useRef, useState } from 'react';
import styles from './AssessmentReport.module.css';
import { Scroller } from '../scroller/Scroller';
import { useGlobalContext } from '@/libs/context/GlobalContext';
import Image from 'next/image';
import { AssessmentCheckoutForm } from './AssessmentCheckoutForm';
type props = {
    data: any
}
export function AssessmentProductPlan({ data }: props) {
    const [isActive, setIsActive] = useState(true);
    const productPlan = data && data.product_plan && data.product_plan[0];
    const additionalProducts = data && data.additional_products && data.additional_products;
    const productPriceDetails = data && data.product_price_detail_arr && data.product_price_detail_arr;
    const { props: { isMobileView } } = useGlobalContext();
    const ref = useRef(null);
    return <section className={`${styles.treatment_sec} pt50 pb50`} style={{ backgroundColor: "#f9f9f9" }}>
        <div className="container">
            <div className={styles.max_container}>
                <div className={styles.header_plan}>
                    <div className={styles.title_plan}>
                        <h2>Your Personalised Treatment Plan</h2>
                    </div>
                    <span className={styles.mothly_plan}>{productPlan.package_period || "1 Month Plan"}</span>
                </div>
                <div className={styles.treatment_plan}>
                    <div className={styles.grid_wrapper}>
                        <div className={`${styles.flex_itms_icon} ${isActive && styles.active}`} id="toggleButton" onClick={() => setIsActive(!isActive)}>
                            <div className={styles.icon_text_box}>
                                <span className={styles.icon}>
                                    <Image src={productPlan.image1 || "/assets/images/your-sexual-kit.svg"} height={30} width={30} alt='' />
                                </span>
                                <h4>{productPlan.productname}</h4>
                            </div>
                            <div className={styles.price_top}>
                                <small>Prices</small>
                                <strong className={styles.price}>₹ {productPlan.mrp_price}</strong>
                            </div>
                        </div>
                        <div id="contentDiv" className={`${styles.contentDiv} `} style={{ display: `${isActive ? "block" : ''}` }}>
                            <div className={styles.row_columngrid} ref={ref}>
                                <div className={`${styles.productSwiper} pb30 `}>
                                    {(productPlan.bundles.filter((f: any) => f.image)).map((f: any, idx: number) =>
                                        <div className={`${styles.custom_slide_pro} productSwiper`} key={idx}>
                                            <div className={styles.column_v}>
                                                <div className={styles.img_box_col}>
                                                    <Image src={f.image} width={291} height={204} alt={f.bundleName} />
                                                </div>
                                                <div className={styles.content_v}>
                                                    <h4>{f.bundleName}</h4>
                                                    <div>
                                                        <p>{f.product_desc}</p>
                                                        <div className={styles.ratting}>
                                                            <ul>
                                                                <li><span><img src="/assets/images/star.svg" alt="star ratting" /></span></li>
                                                                <li><span><img src="/assets/images/star.svg" alt="star ratting" /></span></li>
                                                                <li><span><img src="/assets/images/star.svg" alt="star ratting" /></span></li>
                                                                <li><span><img src="/assets/images/star.svg" alt="star ratting" /></span></li>
                                                                <li><span><img src="/assets/images/star-half.svg" alt="star ratting" /></span></li>
                                                                <li>(4.9)</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <Scroller scrollContainerRef={ref} noOfTile={productPlan.bundles.filter((f: any) => f.image)} tileClass={'productSwiper'} tilesToView={isMobileView ? 1 : 4} arrowsNotReq={true} extraWidth={isMobileView ? 16 : 16} />
                        </div>
                        {additionalProducts.map((m: any, idx: number) =>
                            <div className={styles.flex_itms_icon} key={idx}>
                                <div className={styles.icon_text_box}>
                                    <span className={styles.icon}>
                                        <Image src={m.product_icon || "/assets/images/authentic-medicines.svg"} width={30} height={30} alt={m.product_name} />
                                    </span>
                                    <h4>{m.product_name}</h4>
                                </div>
                                <div className={styles.price_top}>
                                    <small>Free</small>
                                    <strong className={styles.price}>₹ {m.price}</strong>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className={`${styles.your_plan_total} textcenter`} id="shipping_payment">
                        <h4 className="text333 font20 fontsm16">Your Plan <span className="text46675 fontThin">₹ {productPriceDetails.total_price_without_discount}</span> <b className="font30"> ₹ {productPriceDetails.total_price_with_discount} </b> </h4>
                        <div className={styles.coupon_data}>
                            <p className="text666" id='buyNow'><Image src="/assets/images/horn.png" height={36} width={36} alt='horn' /> Cheers! <b className="text46675">You Saved ₹ {productPriceDetails.total_discount}</b></p>
                        </div>
                        <div className={styles.plan_tretBox}><button className={`btn btn-primary ${styles.buy_now_btn} buyNowBtn`} >Buy Now</button></div>
                    </div>
                    <AssessmentCheckoutForm />
                </div>


            </div>
        </div>


    </section>
}